import PlaylistAddOutlinedIcon from '@mui/icons-material/PlaylistAddOutlined';
import { Stack, Typography } from '@mui/material';

type ActualizationTableEmptyProps = {
  message: string;
};

export const ActualizationTableEmpty = ({ message }: ActualizationTableEmptyProps) => (
  <Stack
    direction="row"
    alignItems="center"
    spacing={0.75}
    sx={{
      px: 1.25,
      py: 0.75,
      minHeight: 40,
      border: '1px dashed',
      borderColor: 'divider',
      borderRadius: 1,
      bgcolor: 'action.hover',
    }}>
    <PlaylistAddOutlinedIcon sx={{ fontSize: 16, color: 'text.disabled' }} />
    <Typography color="text.secondary" sx={{ fontSize: '12px', lineHeight: 1.3 }}>
      {message}
    </Typography>
  </Stack>
);
